var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"base-close-modal"},[_c('img',{attrs:{"src":require("@/assets/icons/close-icon.png"),"width":"auto","height":"25"},on:{"click":function($event){return _vm.$emit('click')}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }